export class NodePoly {
  constructor() {
    this.fID = -1;
    this.fPoints = null;
    this.fSides = null;
    this.fLefts = null;
    this.fRights = null;
    this.fBottoms = null;
    this.fLeftMosts = null;
    this.fRightMosts = null;
    this.fTopMosts = null;
    this.fBottomMosts = null;
    this.fVisibleSidesCalculated = false;
    this.fVisibleLefts = null;
    this.fVisibleRights = null;
    this.fVisibleTops = null;
    this.fVisibleBottoms = null;
    this.fEnvelope = null;
    this.fName = "undef";
    this.fColor = 0;
    this.fValid = false;
  }

  InitNodePoly(points, name, color) {
    if (points.length < 4) {
      return;
    }

    this.fID = -1;
    this.fName = name;
    this.fColor = color;
    this.fPoints = [];
    this.fSides = [];
    this.fLefts = [];
    this.fRights = [];
    this.fTops = [];
    this.fBottoms = [];
    this.fLeftMosts = [];
    this.fRightMosts = [];
    this.fTopMosts = [];
    this.fBottomMosts = [];
    this.fVisibleSidesCalculated = false;
    this.fValid = true;

    var xmin = Number.POSITIVE_INFINITY;
    var ymin = Number.POSITIVE_INFINITY;
    var xmax = Number.NEGATIVE_INFINITY;
    var ymax = Number.NEGATIVE_INFINITY;
    var iSideIndex = 0;
    for (var i = 0; i < points.length; i++) {
      var iNext = i + 1;
      if (iNext >= points.length) {
        iNext = 0;
      }

      var previousSide = null;
      if (i > 0) {
        previousSide = this.fSides[this.fSides.length - 1];
      }

      // determining side type
      if (points[i].x === points[iNext].x) {
        if (points[i].y > points[iNext].y) {
          var sideType = "right";
        } else {
          sideType = "left";
        }
      } else if (points[i].y === points[iNext].y) {
        if (points[i].x < points[iNext].x) {
          sideType = "bottom";
        } else {
          sideType = "top";
        }
      }

      this.fPoints.push({ x: points[i].x, y: points[i].y });
      var newSide = {
        p1: points[i],
        p2: points[iNext],
        type: sideType
      };

      if (previousSide != null && sideType === previousSide.type) {
        // this side is continuation of previous side. just updated side and move on
        this.fPoints.pop();
        var lastSideP1 = this.fSides[this.fSides.length - 1].p1;
        newSide.p1 = { x: lastSideP1.x, y: lastSideP1.y };
        this.fSides.pop();
        switch (sideType) {
          case "left":
            this.fLefts.pop();
            break;

          case "right":
            this.fRights.pop();
            break;

          case "top":
            this.fTops.pop();
            break;

          case "bottom":
            this.fBottoms.pop();
            break;

          default:
            break;
        }
      }

      this.fSides.push(newSide);
      iSideIndex = this.fSides.length - 1;

      xmin = Math.min(xmin, points[i].x);
      ymin = Math.min(ymin, points[i].y);
      xmax = Math.max(xmax, points[i].x);
      ymax = Math.max(ymax, points[i].y);

      // fill in tops, bottoms, rights and lefts
      switch (sideType) {
        case "left":
          this.fLefts.push(iSideIndex);
          break;

        case "right":
          this.fRights.push(iSideIndex);
          break;

        case "top":
          this.fTops.push(iSideIndex);
          break;

        case "bottom":
          this.fBottoms.push(iSideIndex);
          break;

        default:
          break;
      }
    }

    // populate "Most" list
    for (i = 0; i < this.fTops.length; i++) {
      if (this.fTopMosts.length > 0) {
        if (this.fSides[this.fTopMosts[0]].p1.y > this.fSides[this.fTops[i]].p1.y) {
          this.fTopMosts.length = 0;
        } else if (this.fSides[this.fTopMosts[0]].p1.y === this.fSides[this.fTops[i]].p1.y) {
          this.fTopMosts.push(this.fTops[i]);
        }
      }
      if (this.fTopMosts.length === 0) {
        this.fTopMosts.push(this.fTops[i]);
      }
    }

    for (i = 0; i < this.fBottoms.length; i++) {
      if (this.fBottomMosts.length > 0) {
        if (this.fSides[this.fBottomMosts[0]].p1.y < this.fSides[this.fBottoms[i]].p1.y) {
          this.fBottomMosts.length = 0;
        } else if (this.fSides[this.fBottomMosts[0]].p1.y === this.fSides[this.fBottoms[i]].p1.y) {
          // ensure first index in this.fBottomMost is indeed also the bottom most left most index
          if (this.fSides[this.fBottoms[i]].p1.x < this.fSides[this.fBottomMosts[0]].p1.x) {
            this.fBottomMosts.unshift(this.fBottoms[i]);
          } else {
            this.fBottomMosts.push(this.fBottoms[i]);
          }
        }
      }
      if (this.fBottomMosts.length === 0) {
        this.fBottomMosts.push(this.fBottoms[i]);
      }
    }

    for (i = 0; i < this.fLefts.length; i++) {
      if (this.fLeftMosts.length > 0) {
        if (this.fSides[this.fLeftMosts[0]].p1.x > this.fSides[this.fLefts[i]].p1.x) {
          this.fLeftMosts.length = 0;
        } else if (this.fSides[this.fLeftMosts[0]].p1.x === this.fSides[this.fLefts[i]].p1.x) {
          this.fLeftMosts.push(this.fLefts[i]);
        }
      }
      if (this.fLeftMosts.length === 0) {
        this.fLeftMosts.push(this.fLefts[i]);
      }
    }

    for (i = 0; i < this.fRights.length; i++) {
      if (this.fRightMosts.length > 0) {
        if (this.fSides[this.fRightMosts[0]].p1.x < this.fSides[this.fRights[i]].p1.x) {
          this.fRightMosts.length = 0;
        } else if (this.fSides[this.fRightMosts[0]].p1.x === this.fSides[this.fRights[i]].p1.x) {
          this.fRightMosts.push(this.fRights[i]);
        }
      }
      if (this.fRightMosts.length === 0) {
        this.fRightMosts.push(this.fRights[i]);
      }
    }

    this.fEnvelope = {
      fLeft: xmin,
      fRight: xmax,
      fTop: ymin,
      fBottom: ymax,
      fWidth: xmax - xmin,
      fHeight: ymax - ymin
    };
  }

  InitNodePolyFromBox(box, name, color) {
    if (box.left < box.right && box.top < box.bottom) {
      var points = [];
      points.push({ x: box.left, y: box.top });
      points.push({ x: box.left, y: box.bottom });
      points.push({ x: box.right, y: box.bottom });
      points.push({ x: box.right, y: box.top });
      this.InitNodePoly(points, name, color);
      this.fValid = true;
    } else {
      this.fValid = false;
      //console.log("an invalid poly ...");
    }
  }

  MakeInvalid() {
    this.fValid = false;
    // hopefully garbage collection shall be done by others
  }

  Clone() {
    var c = new NodePoly();
    c.fID = this.fID;
    c.fName = this.fName;
    c.fColor = this.fColor;
    c.fValid = this.fValid;

    // Shallow copy via .slice() is safe — MovePoly creates new objects rather than
    // mutating existing point/side objects, so shared references are safe.
    c.fPoints = this.fPoints ? this.fPoints.slice() : null;
    c.fSides = this.fSides ? this.fSides.slice() : null;
    c.fLefts = this.fLefts ? this.fLefts.slice() : null;
    c.fRights = this.fRights ? this.fRights.slice() : null;
    c.fTops = this.fTops ? this.fTops.slice() : null;
    c.fBottoms = this.fBottoms ? this.fBottoms.slice() : null;
    c.fLeftMosts = this.fLeftMosts ? this.fLeftMosts.slice() : null;
    c.fRightMosts = this.fRightMosts ? this.fRightMosts.slice() : null;
    c.fTopMosts = this.fTopMosts ? this.fTopMosts.slice() : null;
    c.fBottomMosts = this.fBottomMosts ? this.fBottomMosts.slice() : null;

    c.fVisibleSidesCalculated = this.fVisibleSidesCalculated;

    if (this.fVisibleSidesCalculated) {
      c.fVisibleLefts = this.fVisibleLefts.slice();
      c.fVisibleRights = this.fVisibleRights.slice();
      c.fVisibleTops = this.fVisibleTops.slice();
      c.fVisibleBottoms = this.fVisibleBottoms.slice();
    }
    if (this.fEnvelope == null) console.log("uh oh");
    c.fEnvelope = {
      fLeft: this.fEnvelope.fLeft,
      fRight: this.fEnvelope.fRight,
      fTop: this.fEnvelope.fTop,
      fBottom: this.fEnvelope.fBottom,
      fWidth: this.fEnvelope.fWidth,
      fHeight: this.fEnvelope.fHeight
    };

    return c;
  }

  CloneFromOther(other) {
    this.fID = other.fID;
    this.fName = other.fName;
    this.fColor = other.fColor;
    this.fValid = other.fValid;

    this.fPoints = other.fPoints ? other.fPoints.slice() : [];
    this.fSides = other.fSides ? other.fSides.slice() : [];
    this.fLefts = other.fLefts ? other.fLefts.slice() : [];
    this.fRights = other.fRights ? other.fRights.slice() : [];
    this.fTops = other.fTops ? other.fTops.slice() : [];
    this.fBottoms = other.fBottoms ? other.fBottoms.slice() : [];
    this.fLeftMosts = other.fLeftMosts ? other.fLeftMosts.slice() : [];
    this.fRightMosts = other.fRightMosts ? other.fRightMosts.slice() : [];
    this.fTopMosts = other.fTopMosts ? other.fTopMosts.slice() : [];
    this.fBottomMosts = other.fBottomMosts ? other.fBottomMosts.slice() : [];

    this.fVisibleSidesCalculated = other.fVisibleSidesCalculated;

    if (other.fVisibleSidesCalculated) {
      this.fVisibleLefts = other.fVisibleLefts.slice();
      this.fVisibleRights = other.fVisibleRights.slice();
      this.fVisibleTops = other.fVisibleTops.slice();
      this.fVisibleBottoms = other.fVisibleBottoms.slice();
    } else {
      this.fVisibleLefts = [];
      this.fVisibleRights = [];
      this.fVisibleTops = [];
      this.fVisibleBottoms = [];
    }

    this.fEnvelope = {
      fLeft: other.fEnvelope.fLeft,
      fRight: other.fEnvelope.fRight,
      fTop: other.fEnvelope.fTop,
      fBottom: other.fEnvelope.fBottom,
      fWidth: other.fEnvelope.fWidth,
      fHeight: other.fEnvelope.fHeight
    };
  }

  /**
   * @return {number}
   */
  GetHeight() {
    if (this.fEnvelope === null) {
      return 0;
    } else {
      return this.fEnvelope.fHeight;
    }
  }

  /**
   * @return {number}
   */
  GetWidth() {
    if (this.fEnvelope === null) {
      return 0;
    } else {
      return this.fEnvelope.fWidth;
    }
  }

  // some accessors for properties of NodePoly
  MovePoly(delta) {
    for (var i = 0; i < this.fPoints.length; i++) {
      this.fPoints[i] = {
        x: this.fPoints[i].x + delta.x,
        y: this.fPoints[i].y + delta.y
      };
    }

    for (i = 0; i < this.fSides.length; i++) {
      var side = this.fSides[i];
      this.fSides[i] = {
        p1: { x: side.p1.x + delta.x, y: side.p1.y + delta.y },
        p2: { x: side.p2.x + delta.x, y: side.p2.y + delta.y },
        type: side.type
      };
    }
    this.fEnvelope.fLeft += delta.x;
    this.fEnvelope.fRight += delta.x;
    this.fEnvelope.fTop += delta.y;
    this.fEnvelope.fBottom += delta.y;

    if (this.fVisibleSidesCalculated) {
      for (i = 0; i < this.fVisibleLefts.length; i++) {
        side = this.fVisibleLefts[i];
        this.fVisibleLefts[i] = {
          p1: { x: side.p1.x + delta.x, y: side.p1.y + delta.y },
          p2: { x: side.p2.x + delta.x, y: side.p2.y + delta.y },
          type: side.type
        };
      }

      for (i = 0; i < this.fVisibleRights.length; i++) {
        side = this.fVisibleRights[i];
        this.fVisibleRights[i] = {
          p1: { x: side.p1.x + delta.x, y: side.p1.y + delta.y },
          p2: { x: side.p2.x + delta.x, y: side.p2.y + delta.y },
          type: side.type
        };
      }

      for (i = 0; i < this.fVisibleTops.length; i++) {
        side = this.fVisibleTops[i];
        this.fVisibleTops[i] = {
          p1: { x: side.p1.x + delta.x, y: side.p1.y + delta.y },
          p2: { x: side.p2.x + delta.x, y: side.p2.y + delta.y },
          type: side.type
        };
      }

      for (i = 0; i < this.fVisibleBottoms.length; i++) {
        side = this.fVisibleBottoms[i];
        this.fVisibleBottoms[i] = {
          p1: { x: side.p1.x + delta.x, y: side.p1.y + delta.y },
          p2: { x: side.p2.x + delta.x, y: side.p2.y + delta.y },
          type: side.type
        };
      }
    }
  }

  /**
   calculates the horizontal distance between this nodepoly and nodePoly2
   distance is positive if nodePoly2 is on the right of this
   distance is infinite if they do not have vertical overlap

   * @return {number}
   */
  HorizontalDistance(nodePoly2) {
    var hdist = Number.POSITIVE_INFINITY;
    if (this.fValid && nodePoly2 != null && nodePoly2.fValid) {
      // Fast-path: for simple box polygons (1 right side, 1 left side), skip nested loop
      if (this.fRights.length === 1 && nodePoly2.fLefts.length === 1) {
        var rightSide = this.fSides[this.fRights[0]];
        var leftSide = nodePoly2.fSides[nodePoly2.fLefts[0]];
        if (
          (rightSide.p2.y >= leftSide.p1.y && rightSide.p2.y < leftSide.p2.y) ||
          (leftSide.p1.y < rightSide.p1.y && leftSide.p1.y >= rightSide.p2.y)
        ) {
          hdist = leftSide.p1.x - rightSide.p1.x;
        }
      } else {
        // General case: check all right sides against all left sides
        for (var i1 = 0; i1 < this.fRights.length; i1++) {
          for (var i2 = 0; i2 < nodePoly2.fLefts.length; i2++) {
            rightSide = this.fSides[this.fRights[i1]];
            leftSide = nodePoly2.fSides[nodePoly2.fLefts[i2]];
            if (
              (rightSide.p2.y >= leftSide.p1.y && rightSide.p2.y < leftSide.p2.y) ||
              (leftSide.p1.y < rightSide.p1.y && leftSide.p1.y >= rightSide.p2.y)
            ) {
              hdist = Math.min(hdist, leftSide.p1.x - rightSide.p1.x);
            }
          }
        }
      }
    }

    return hdist;
  }

  log(LogMessage) {
    console.log(LogMessage);
    console.log("Poly " + this.fID + " " + this.fName);
    if (this.fSides == null) {
      return;
    }

    for (var i = 0; i < this.fSides.length; i++) {
      console.log(
        i + " (" + this.fSides[i].p1.x + "," + this.fSides[i].p1.y + ") --> (",
        this.fSides[i].p2.x + "," + this.fSides[i].p2.y + ") " + this.fSides[i].type
      );
    }
  }

  logPointsOnly(LogMessage, LogColor) {
    if (typeof LogColor === "undefined") {
      LogColor = "[0.7 0.9 0.5 0.2]";
    }
    var PolyMessage =
      LogMessage +
      "p = constructPoly(" +
      LogMessage +
      ", '" +
      LogMessage +
      "', " +
      LogColor +
      "); %";
    LogMessage += " = [";
    if (this.fPoints === null) {
      return;
    }

    for (var i = 0; i < this.fPoints.length; i++) {
      if (i > 0) {
        LogMessage += "; ";
      }
      LogMessage += this.fPoints[i].x + "," + this.fPoints[i].y;
    }

    LogMessage += "]; ";
    console.log(LogMessage + PolyMessage);
  }

  /**
   * @return {number}
   */
  NextSideIndex(sideIndex) {
    var nextSideIndex = sideIndex + 1;
    if (nextSideIndex >= this.fSides.length || nextSideIndex < 0) {
      nextSideIndex = 0;
    }

    return nextSideIndex;
  }

  /**
   * @return {number}
   */
  VerticalDistance(nodePoly2) {
    var vdist = Number.POSITIVE_INFINITY;
    if (this.fValid && nodePoly2 != null && nodePoly2.fValid) {
      for (var i1 = 0; i1 < this.fBottoms.length; i1++) {
        for (var i2 = 0; i2 < nodePoly2.fTops.length; i2++) {
          var bottomSide = this.fSides[this.fBottoms[i1]];
          var topSide = nodePoly2.fSides[nodePoly2.fTops[i2]];
          if (
            (bottomSide.p2.x > topSide.p2.x && bottomSide.p2.x <= topSide.p1.x) ||
            (topSide.p1.x > bottomSide.p1.x && topSide.p1.x <= bottomSide.p2.x)
          ) {
            vdist = Math.min(vdist, topSide.p1.y - bottomSide.p1.y);
          }
        }
      }
    }

    return vdist;
  }

  // This becomes a merged result of nodePoly1 and nodePoly2
  Merge(nodePoly1, nodePoly2, MergeType) {
    if (nodePoly1 === null || nodePoly2 === null || !nodePoly1.fValid || !nodePoly2.fValid) {
      return;
    }

    var nodePolyC = null;
    if (typeof MergeType === "undefined") {
      nodePolyC = nodePoly1;
    } else {
      var polyConnector = new NodePoly();
      polyConnector.ConnectorPoly(nodePoly1, nodePoly2, MergeType);
      nodePolyC = new NodePoly();
      nodePolyC = nodePoly1.Clone();
      nodePolyC.Merge(nodePolyC, polyConnector);
    }

    var iStart = -1;
    var activePoly;
    var otherPoly;
    if (
      nodePolyC.fSides[nodePolyC.fLeftMosts[0]].p1.x <=
      nodePoly2.fSides[nodePoly2.fLeftMosts[0]].p1.x
    ) {
      iStart = nodePolyC.fLeftMosts[0];
      activePoly = nodePolyC;
      otherPoly = nodePoly2;
    } else {
      iStart = nodePoly2.fLeftMosts[0];
      activePoly = nodePoly2;
      otherPoly = nodePolyC;
    }

    var onStartingPoly = true;
    var pointsMerged = []; // holds the vertices of merged polygon
    pointsMerged.push({
      x: activePoly.fSides[iStart].p1.x,
      y: activePoly.fSides[iStart].p1.y
    });
    var currentSideIndex = iStart;
    var keepAddingPoints = true;
    while (
      keepAddingPoints &&
      pointsMerged.length <= nodePolyC.fPoints.length + nodePoly2.fPoints.length
    ) {
      // is any side from non-active poly touching current side?
      var currentSide = activePoly.fSides[currentSideIndex];

      // does any of the other poly touches current side
      var lastPointAdded = pointsMerged[pointsMerged.length - 1];
      var otherSideTouchIndex = otherPoly.ClosestSideTouching(currentSide, lastPointAdded);
      if (-1 === otherSideTouchIndex) {
        // no other side is touching and we can safely continue to p2 of this side
        // and check if this p2 is on any side of other shape.
        pointsMerged.push({ x: currentSide.p2.x, y: currentSide.p2.y });
        var otherSideIndex = otherPoly.SideIndexP2On(currentSide);
        if (-1 === otherSideIndex) {
          // not contacting with other poly... continue
          currentSideIndex = activePoly.NextSideIndex(currentSideIndex);
        } else {
          // contact happened with other poly. Switch sides
          var tmpPoly = activePoly;
          activePoly = otherPoly;
          otherPoly = tmpPoly;
          onStartingPoly = !onStartingPoly;
          currentSideIndex = otherSideIndex;
        }

        if (currentSideIndex === iStart && onStartingPoly) {
          // we are done. Good job
          keepAddingPoints = false;
        }
      } else {
        // a side from another poly has come to contact with current side. We need to switch sides
        // but also need to add p1 of next side of this
        tmpPoly = activePoly;
        activePoly = otherPoly;
        otherPoly = tmpPoly;
        onStartingPoly = !onStartingPoly;
        currentSideIndex = activePoly.NextSideIndex(otherSideTouchIndex);
        currentSide = activePoly.fSides[currentSideIndex];
        pointsMerged.push({ x: currentSide.p1.x, y: currentSide.p1.y });
      }
    }

    if (keepAddingPoints) {
      // this should not happen. it means the while loop was getting into infinite loop
      this.MakeInvalid();
    } else {
      var mergedPolyName = nodePolyC.fName + nodePoly2.fName;
      // last point is redundant and needs to be removed
      pointsMerged.pop();
      this.InitNodePoly(pointsMerged, mergedPolyName, nodePolyC.color);
    }
  }

  /**
   * @return {boolean}
   */
  MergeFar(polyMerged, poly1, poly2, minDistance) {
    if (poly1 === null || poly2 === null || !poly1.fValid || !poly2.fValid) {
      return false;
    }

    // first check if any of the distances between the two are within minDistance. If not, just return and do nothing
    var distanceOk = false;
    var mergeType = "none";
    var polyLocal1, polyLocal2;
    var hDistance = poly1.HorizontalDistance(poly2);
    if (hDistance < 0 || hDistance > minDistance) {
      hDistance = poly2.HorizontalDistance(poly1);
      if (hDistance < 0 || hDistance > minDistance) {
        var vDistance = poly1.VerticalDistance(poly2);
        if (vDistance < 0 || vDistance > minDistance) {
          vDistance = poly2.VerticalDistance(poly1);
          if (vDistance > 0 && vDistance <= minDistance) {
            distanceOk = true;
            mergeType = "vertical";
            polyLocal1 = poly2;
            polyLocal2 = poly1;
          }
        } else {
          distanceOk = true;
          mergeType = "vertical";
          polyLocal1 = poly1;
          polyLocal2 = poly2;
        }
      } else {
        distanceOk = true;
        mergeType = "horizontal";
        polyLocal1 = poly2;
        polyLocal2 = poly1;
      }
    } else {
      distanceOk = true;
      mergeType = "horizontal";
      polyLocal1 = poly1;
      polyLocal2 = poly2;
    }

    if (!distanceOk) {
      return false;
    }

    var boxes = this.ConnectingBoxes(polyLocal1, polyLocal2, mergeType, minDistance);
    if (boxes.length === 0) {
      return false;
    }

    polyMerged.poly = polyLocal1.Clone();
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var polyB = new NodePoly();
      polyB.InitNodePolyFromBox(box);
      polyMerged.poly.Merge(polyMerged.poly, polyB);
    }
    polyMerged.poly.Merge(polyMerged.poly, polyLocal2);
    polyMerged.poly.FillTopCave(minDistance);

    polyMerged.poly.FillRightCave(minDistance);

    return true;
  }

  // polyMerged.poly becomes a merged combination of two poly sets if they are closer than minDistance
  ConnectingBoxes(poly1, poly2, type, minDistance) {
    // first calculate visible sides. If they are already calculated, this routine just returns.
    poly1.CalculateVisibleSides();
    poly2.CalculateVisibleSides();

    var boxes = [];
    var i,
      j = 0;
    switch (type) {
      case "horizontal":
        for (i = 0; i < poly1.fVisibleRights.length; i++) {
          var side1 = poly1.fVisibleRights[i];
          for (j = 0; j < poly2.fVisibleLefts.length; j++) {
            var side2 = poly2.fVisibleLefts[j];
            var distance = side2.p1.x - side1.p1.x;
            if (distance > 0 && distance <= minDistance) {
              var topY = Math.max(side1.p2.y, side2.p1.y);
              var botY = Math.min(side1.p1.y, side2.p2.y);
              if (topY < botY) {
                var box = {
                  left: side1.p1.x,
                  right: side2.p1.x,
                  top: topY,
                  bottom: botY
                };
                boxes.push(box);
              }
            }
          }
        }
        break;

      case "vertical":
        for (i = 0; i < poly1.fVisibleBottoms.length; i++) {
          side1 = poly1.fVisibleBottoms[i];
          for (j = 0; j < poly2.fVisibleTops.length; j++) {
            side2 = poly2.fVisibleTops[j];
            distance = side2.p1.y - side1.p1.y;
            if (distance > 0 && distance <= minDistance) {
              var leftX = Math.max(side1.p1.x, side2.p2.x);
              var rightX = Math.min(side1.p2.x, side2.p1.x);
              if (leftX < rightX) {
                box = {
                  left: leftX,
                  right: rightX,
                  top: side1.p1.y,
                  bottom: side2.p1.y
                };
                boxes.push(box);
              }
            }
          }
        }

        break;

      default:
        break;
    }

    return boxes;
  }

  // returns the next adjacent side index
  CalculateVisibleSides() {
    if (!this.fVisibleSidesCalculated) {
      this.fVisibleSidesCalculated = true;

      var visibles = [];
      var sides = [];

      // left visible
      this.fVisibleLefts = [];
      visibles.length = 0;
      sides.length = 0;
      for (var i = 0; i < this.fLefts.length; i++) {
        var leftSide = this.fSides[this.fLefts[i]];
        var sideType = leftSide.type;
        var side = {
          p1: { x: leftSide.p1.y, y: -leftSide.p1.x },
          p2: { x: leftSide.p2.y, y: -leftSide.p2.x }
        };
        sides.push(side);
      }

      visibles = this.GetAllVisibles(sides);
      for (i = 0; i < visibles.length; i++) {
        var vSide = visibles[i];
        var leftVisibleSide = {
          p1: { x: -vSide.p1.y, y: vSide.p1.x },
          p2: { x: -vSide.p2.y, y: vSide.p2.x },
          type: sideType
        };
        this.fVisibleLefts.push(leftVisibleSide);
      }

      // right visible
      this.fVisibleRights = [];
      visibles.length = 0;
      sides.length = 0;
      for (i = 0; i < this.fRights.length; i++) {
        var rightSide = this.fSides[this.fRights[i]];
        sideType = rightSide.type;
        side = {
          p1: { x: -rightSide.p1.y, y: rightSide.p1.x },
          p2: { x: -rightSide.p2.y, y: rightSide.p2.x }
        };
        sides.push(side);
      }

      visibles = this.GetAllVisibles(sides);
      for (i = 0; i < visibles.length; i++) {
        vSide = visibles[i];
        var rightVisibleSide = {
          p1: { x: vSide.p1.y, y: -vSide.p1.x },
          p2: { x: vSide.p2.y, y: -vSide.p2.x },
          type: sideType
        };
        this.fVisibleRights.push(rightVisibleSide);
      }

      // top visible
      this.fVisibleTops = [];
      visibles.length = 0;
      sides.length = 0;
      for (i = 0; i < this.fTops.length; i++) {
        var topSide = this.fSides[this.fTops[i]];
        sideType = topSide.type;
        side = {
          p1: { x: -topSide.p1.x, y: -topSide.p1.y },
          p2: { x: -topSide.p2.x, y: -topSide.p2.y }
        };
        sides.push(side);
      }

      visibles = this.GetAllVisibles(sides);
      for (i = 0; i < visibles.length; i++) {
        vSide = visibles[i];
        var topVisibleSide = {
          p1: { x: -vSide.p1.x, y: -vSide.p1.y },
          p2: { x: -vSide.p2.x, y: -vSide.p2.y },
          type: sideType
        };
        this.fVisibleTops.push(topVisibleSide);
      }

      // bottom visible
      this.fVisibleBottoms = [];
      visibles.length = 0;
      sides.length = 0;
      for (i = 0; i < this.fBottoms.length; i++) {
        var bottomSide = this.fSides[this.fBottoms[i]];
        sideType = bottomSide.type;
        side = {
          p1: { x: bottomSide.p1.x, y: bottomSide.p1.y },
          p2: { x: bottomSide.p2.x, y: bottomSide.p2.y }
        };
        sides.push(side);
      }

      visibles = this.GetAllVisibles(sides);
      for (i = 0; i < visibles.length; i++) {
        vSide = visibles[i];
        var bottomVisibleSide = {
          p1: { x: vSide.p1.x, y: vSide.p1.y },
          p2: { x: vSide.p2.x, y: vSide.p2.y },
          type: sideType
        };
        this.fVisibleBottoms.push(bottomVisibleSide);
      }
    }
  }

  GetAllVisibles(sides, gap) {
    var visibleSides = [];
    if (typeof gap === "undefined") {
      gap = { x1: Number.POSITIVE_INFINITY, x2: Number.NEGATIVE_INFINITY };
      for (var i = 0; i < sides.length; i++) {
        var side = sides[i];
        if (side.p1.x < gap.x1) {
          gap.x1 = side.p1.x;
        }

        if (side.p2.x > gap.x2) {
          gap.x2 = side.p2.x;
        }
      }
    }

    var iVisible = this.GetClosestVisible(gap, sides);
    if (iVisible >= 0 && iVisible < sides.length) {
      side = sides[iVisible];
      var vSide = {
        p1: { x: Math.max(gap.x1, side.p1.x), y: side.p1.y },
        p2: { x: Math.min(gap.x2, side.p2.x), y: side.p1.y }
      };
      visibleSides.push(vSide);
      var gap1 = { x1: gap.x1, x2: vSide.p1.x };
      var gap2 = { x1: vSide.p2.x, x2: gap.x2 };
      if (gap1.x2 > gap1.x1) {
        var sides1 = this.GetAllVisibles(sides, gap1);
        if (sides1.length > 0) {
          visibleSides = visibleSides.concat(sides1);
        }
      }

      if (gap2.x2 > gap2.x1) {
        var sides2 = this.GetAllVisibles(sides, gap2);
        if (sides2.length > 0) {
          visibleSides = visibleSides.concat(sides2);
        }
      }
    }

    return visibleSides;
  }

  /**
   * @return {number}
   */
  GetClosestVisible(gap, sides) {
    var g1 = gap.x1;
    var g2 = gap.x2;
    var iMax = -1;
    if (g1 === g2 || sides.length === 0) {
      return iMax;
    }

    var maxY = Number.NEGATIVE_INFINITY;
    for (var i = 0; i < sides.length; i++) {
      var side = sides[i];
      var x1 = side.p1.x;
      var x2 = side.p2.x;
      if (
        side.p1.y >= maxY &&
        ((x1 >= g1 && x1 < g2) || (x2 <= g2 && x2 > g1) || (x1 <= g1 && x2 >= g2))
      ) {
        maxY = side.p1.y;
        iMax = i;
      }
    }

    return iMax;
  }

  /**
   * @return {boolean}
   */
  FillTopCave(minDistance) {
    var filledCave = false;
    var foundCave = false;
    for (var i = 0; i < this.fRights.length; i++) {
      var sideR = this.fSides[this.fRights[i]];
      for (var j = 0; j < this.fLefts.length; j++) {
        var sideL = this.fSides[this.fLefts[j]];
        var distSides = sideL.p1.x - sideR.p1.x;
        if (distSides > 0 && distSides <= minDistance) {
          var topY = Math.max(sideR.p2.y, sideL.p1.y);
          var botY = Math.min(sideR.p1.y, sideL.p2.y);
          if (topY < botY) {
            foundCave = true;
            minDistance = distSides;
            var box = {
              left: sideL.x,
              right: sideR.x,
              top: topY,
              bottom: botY
            };
          }
        }
      }
    }

    if (foundCave) {
      var boxPoly = new NodePoly();
      boxPoly.InitNodePolyFromBox(box);
      this.Merge(this, boxPoly);
      filledCave = true;
    }

    return filledCave;
  }

  /**
   * @return {boolean}
   */
  FillRightCave(minDistance) {
    var filledCave = false;
    var foundCave = false;
    for (var i = 0; i < this.fTops.length; i++) {
      var sideTop = this.fSides[this.fTops[i]];
      for (var j = 0; j < this.fBottoms.length; j++) {
        var sideBottom = this.fSides[this.fBottoms[j]];
        var distSides = sideTop.p1.y - sideBottom.p1.y;
        if (distSides > 0 && distSides <= minDistance) {
          var leftX = Math.max(sideTop.p2.x, sideBottom.p1.x);
          var rightX = Math.min(sideTop.p1.x, sideBottom.p2.x);
          if (leftX < rightX) {
            foundCave = true;
            minDistance = distSides;
            var box = {
              left: leftX,
              right: rightX,
              top: sideBottom.p1.y,
              bottom: sideTop.p1.y
            };
          }
        }
      }
    }

    if (foundCave) {
      var boxPoly = new NodePoly();
      boxPoly.InitNodePolyFromBox(box);
      this.Merge(this, boxPoly);
      filledCave = true;
    }

    return filledCave;
  }

  // fills in top caves of this poly
  ConnectorPoly(nodePoly1, nodePoly2, ConnectorType) {
    this.MakeInvalid();

    switch (ConnectorType) {
      case "left":
        this.ConnectorPolyLeft(nodePoly1, nodePoly2);
        break;

      case "right":
        this.ConnectorPolyRight(nodePoly1, nodePoly2);
        break;

      case "top":
        this.ConnectorPolyTop(nodePoly1, nodePoly2);
        break;

      default:
        break;
    }
  }

  // makes this poly to be a rectangular shape that connects nodePoly1 and nodePoly2
  // from left side
  ConnectorPolyLeft(nodePoly1, nodePoly2) {
    if (nodePoly1.fLeftMosts == null || nodePoly2.fLeftMosts == null) {
      return;
    }

    if (
      nodePoly1.fSides[nodePoly1.fLeftMosts[0]].p1.x !==
      nodePoly2.fSides[nodePoly2.fLeftMosts[0]].p1.x
    ) {
      return;
    }

    var y1 = Number.NEGATIVE_INFINITY;
    for (var i = 0; i < nodePoly1.fLeftMosts.length; i++) {
      y1 = Math.max(y1, nodePoly1.fSides[nodePoly1.fLeftMosts[i]].p2.y);
    }

    var y2 = Number.POSITIVE_INFINITY;
    for (i = 0; i < nodePoly2.fLeftMosts.length; i++) {
      y2 = Math.min(y2, nodePoly2.fSides[nodePoly2.fLeftMosts[i]].p1.y);
    }

    if (y2 > y1) {
      var x1 = nodePoly1.fSides[nodePoly1.fLeftMosts[0]].p1.x;
      var points = [];
      points.push({ x: x1, y: y2 });
      points.push({ x: x1 + 2, y: y2 });
      points.push({ x: x1 + 2, y: y1 });
      points.push({ x: x1, y: y1 });

      var tmpName = nodePoly1.name + "L";
      var tmpColor = nodePoly1.color;
      this.InitNodePoly(points, tmpName, tmpColor);
    }
  }

  // fills in top caves of this poly
  ConnectorPolyRight(nodePoly1, nodePoly2) {
    if (nodePoly1.fRightMosts == null || nodePoly2.fRightMosts == null) {
      return;
    }

    if (
      nodePoly1.fSides[nodePoly1.fRightMosts[0]].p1.x !==
      nodePoly2.fSides[nodePoly2.fRightMosts[0]].p1.x
    ) {
      return;
    }

    var y1 = Number.NEGATIVE_INFINITY;
    for (var i = 0; i < nodePoly1.fRightMosts.length; i++) {
      y1 = Math.max(y1, nodePoly1.fSides[nodePoly1.fRightMosts[i]].p1.y);
    }

    var y2 = Number.POSITIVE_INFINITY;
    for (i = 0; i < nodePoly2.fRightMosts.length; i++) {
      y2 = Math.min(y2, nodePoly2.fSides[nodePoly2.fRightMosts[i]].p2.y);
    }

    if (y2 > y1) {
      var x1 = nodePoly1.fSides[nodePoly1.fRightMosts[0]].p1.x;
      var points = [];
      points.push({ x: x1 - 2, y: y2 });
      points.push({ x: x1, y: y2 });
      points.push({ x: x1, y: y1 });
      points.push({ x: x1 - 2, y: y1 });

      var tmpName = nodePoly1.name + "R";
      var tmpColor = nodePoly1.color;
      this.InitNodePoly(points, tmpName, tmpColor);
    }
  }

  ConnectorPolyTop(nodePoly1, nodePoly2) {
    if (nodePoly1.fTopMosts == null || nodePoly2.fTopMosts == null) {
      return;
    }

    if (
      nodePoly1.fSides[nodePoly1.fTopMosts[0]].p1.y !==
      nodePoly2.fSides[nodePoly2.fTopMosts[0]].p1.y
    ) {
      return;
    }

    var x1 = Number.NEGATIVE_INFINITY;
    for (var i = 0; i < nodePoly1.fTopMosts.length; i++) {
      x1 = Math.max(x1, nodePoly1.fSides[nodePoly1.fTopMosts[i]].p1.x);
    }

    var x2 = Number.POSITIVE_INFINITY;
    for (i = 0; i < nodePoly2.fTopMosts.length; i++) {
      x2 = Math.min(x2, nodePoly2.fSides[nodePoly2.fTopMosts[i]].p2.x);
    }

    if (x1 < x2) {
      var y1 = nodePoly1.fSides[nodePoly1.fTopMosts[0]].p1.y;
      var points = [];
      points.push({ x: x1, y: y1 });
      points.push({ x: x1, y: y1 + 2 });
      points.push({ x: x2, y: y1 + 2 });
      points.push({ x: x2, y: y1 });

      var tmpName = nodePoly1.name + "T";
      var tmpColor = nodePoly1.color;
      this.InitNodePoly(points, tmpName, tmpColor);
    }
  }

  /**
   * @return {number}
   */
  SideIndexP2On(polySide) {
    var SideIndexTouched = -1;
    if (!this.fValid) {
      return SideIndexTouched;
    }

    var point = polySide.p2;

    switch (polySide.type) {
      case "left":
        for (var i = 0; i < this.fTops.length; i++) {
          var topSide = this.fSides[this.fTops[i]];
          if (point.y === topSide.p1.y) {
            if (point.x <= topSide.p1.x && point.x > topSide.p2.x) {
              SideIndexTouched = this.fTops[i];
              return SideIndexTouched;
            }
          }
        }
        break;

      case "right":
        for (i = 0; i < this.fBottoms.length; i++) {
          var bottomSide = this.fSides[this.fBottoms[i]];
          if (point.y === bottomSide.p1.y) {
            if (point.x >= bottomSide.p1.x && point.x < bottomSide.p2.x) {
              SideIndexTouched = this.fBottoms[i];
              return SideIndexTouched;
            }
          }
        }
        break;

      case "top":
        for (i = 0; i < this.fRights.length; i++) {
          var rightSide = this.fSides[this.fRights[i]];
          if (point.x === rightSide.p1.x) {
            if (point.y <= rightSide.p1.y && point.y > rightSide.p2.y) {
              SideIndexTouched = this.fRights[i];
              return SideIndexTouched;
            }
          }
        }
        break;

      case "bottom":
        for (i = 0; i < this.fLefts.length; i++) {
          var leftSide = this.fSides[this.fLefts[i]];
          if (point.x === leftSide.p1.x) {
            if (point.y >= leftSide.p1.y && point.y < leftSide.p2.y) {
              SideIndexTouched = this.fLefts[i];
              return SideIndexTouched;
            }
          }
        }
        break;

      default:
        break;
    }

    // now need to handle special case of p2 being exactly p1 of same type.
    switch (polySide.type) {
      case "top":
        for (i = 0; i < this.fTops.length; i++) {
          topSide = this.fSides[this.fTops[i]];
          if (point.x === topSide.p1.x && point.y === topSide.p1.y) {
            SideIndexTouched = this.fTops[i];
            return SideIndexTouched;
          }
        }
        break;

      case "bottom":
        for (i = 0; i < this.fBottoms.length; i++) {
          bottomSide = this.fSides[this.fBottoms[i]];
          if (point.x === bottomSide.p1.x && point.y === bottomSide.p1.y) {
            SideIndexTouched = this.fBottoms[i];
            return SideIndexTouched;
          }
        }
        break;

      case "right":
        for (i = 0; i < this.fRights.length; i++) {
          rightSide = this.fSides[this.fRights[i]];
          if (point.x === rightSide.p1.x && point.y === rightSide.p1.y) {
            SideIndexTouched = this.fRights[i];
            return SideIndexTouched;
          }
        }
        break;

      case "left":
        for (i = 0; i < this.fLefts.length; i++) {
          leftSide = this.fSides[this.fLefts[i]];
          if (point.x === leftSide.p1.x && point.y === leftSide.p1.y) {
            SideIndexTouched = this.fLefts[i];
            return SideIndexTouched;
          }
        }
        break;

      default:
        break;
    }

    return SideIndexTouched;
  }

  /**
   * @return {number}
   */
  ClosestSideTouching(side, refPoint) {
    var sideTouchedIndex = -1;
    switch (side.type) {
      case "left":
        // need to look at right sides of this
        var yUpLimit = Math.max(side.p1.y, refPoint.y);
        var yDownLimit = side.p2.y;
        for (var i = 0; i < this.fRights.length; i++) {
          var rightSide = this.fSides[this.fRights[i]];
          if (
            rightSide.p1.x === side.p1.x &&
            rightSide.p2.y > yUpLimit &&
            rightSide.p2.y < yDownLimit
          ) {
            sideTouchedIndex = this.fRights[i];
            yDownLimit = rightSide.p2.y;
          }
        }
        break;

      case "right":
        // need to look at left sides of this
        yUpLimit = side.p2.y;
        yDownLimit = Math.min(side.p1.y, refPoint.y);
        for (i = 0; i < this.fLefts.length; i++) {
          var leftSide = this.fSides[this.fLefts[i]];
          if (
            leftSide.p1.x === side.p1.x &&
            leftSide.p2.y > yUpLimit &&
            leftSide.p2.y < yDownLimit
          ) {
            sideTouchedIndex = this.fLefts[i];
            yUpLimit = leftSide.p2.y;
          }
        }
        break;

      case "top":
        var xLeftLimit = side.p2.x;
        var xRightLimit = Math.min(side.p1.x, refPoint.x);
        for (i = 0; i < this.fBottoms.length; i++) {
          var bottomSide = this.fSides[this.fBottoms[i]];
          if (
            bottomSide.p1.y === side.p1.y &&
            bottomSide.p2.x > xLeftLimit &&
            bottomSide.p2.x < xRightLimit
          ) {
            sideTouchedIndex = this.fBottoms[i];
            xLeftLimit = bottomSide.p2.x;
          }
        }
        break;

      case "bottom":
        xLeftLimit = Math.max(side.p1.x, refPoint.x);
        xRightLimit = side.p2.x;
        for (i = 0; i < this.fTops.length; i++) {
          var topSide = this.fSides[this.fTops[i]];
          if (
            topSide.p1.y === side.p1.y &&
            topSide.p2.x > xLeftLimit &&
            topSide.p2.x < xRightLimit
          ) {
            sideTouchedIndex = this.fTops[i];
            xRightLimit = topSide.p2.x;
          }
        }
        break;

      default:
        break;
    }

    return sideTouchedIndex;
  }
}
